export default __webpack_public_path__ + "static/media/property_894.b1136c65.png";